(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    (function(){
  var ROOT = '[data-ptabs]';

  function initAll(scope){
    var nodes = (scope || document).querySelectorAll(ROOT);
    nodes.forEach(function(root){
      if(root.dataset.ptabsInitialized === 'true') return;
      root.dataset.ptabsInitialized = 'true';
      try{
        initTabs(root);
        initClamp(root);
        initAccordionAnimation(root);
      }catch(e){ console.error('ptabs init failed:', e); }
    });
  }

  function initTabs(root){
    var tabs   = Array.prototype.slice.call(root.querySelectorAll('[data-tab-button]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tab-panel]'));
    if(!tabs.length || !panels.length) return;

    function setActive(index, focusTab){
      if(index < 0) index = tabs.length - 1;
      if(index >= tabs.length) index = 0;

      tabs.forEach(function(tab, i){
        tab.classList.toggle('is-active', i === index);
      });
      panels.forEach(function(panel){
        var match = panel.getAttribute('data-tab-panel') === String(index);
        panel.toggleAttribute('hidden', !match);
      });
      if(focusTab && tabs[index]){
        try{ tabs[index].focus({preventScroll:true}); }catch(e){ tabs[index].focus(); }
      }
    }

    tabs.forEach(function(tab, index){
      tab.addEventListener('click', function(){ setActive(index, false); });
      tab.addEventListener('keydown', function(evt){
        var k = evt.key;
        if(k === 'ArrowRight' || k === 'ArrowDown'){ evt.preventDefault(); setActive(index+1, true); }
        else if(k === 'ArrowLeft' || k === 'ArrowUp'){ evt.preventDefault(); setActive(index-1, true); }
        else if(k === 'Home'){ evt.preventDefault(); setActive(0, true); }
        else if(k === 'End'){ evt.preventDefault(); setActive(tabs.length-1, true); }
        else if(k === ' ' || k === 'Spacebar' || k === 'Enter'){ evt.preventDefault(); setActive(index, false); }
      });
    });

    var initial = 0;
    for(var i=0;i<tabs.length;i++){ if(tabs[i].classList.contains('is-active')){ initial=i; break; } }
    setActive(initial, false);
  }

  function initClamp(root){
    var wrap = root.querySelector('[data-clamp]');
    if(!wrap) return;
    var toggle = wrap.querySelector('[data-clamp-toggle]');
    if(!toggle) return;

    var more = (toggle.getAttribute('data-more') || toggle.textContent || '').trim();
    var less = (toggle.getAttribute('data-less') || more).trim();
    toggle.textContent = more;

    toggle.addEventListener('click', function(){
      var expanded = wrap.classList.toggle('is-expanded');
      toggle.textContent = expanded ? less : more;
    });
  }

  /* smooth details animation for Chromium */
  function initAccordionAnimation(root){
    var supports = 'onbeforetoggle' in document.createElement('details');
    if(!supports) return;

    var accords = Array.prototype.slice.call(root.querySelectorAll('.ptabs__mobile details.pacc'));
    accords.forEach(function(d){
      var content = d.querySelector('.pacc__content');
      if(!content) return;

      d.addEventListener('beforetoggle', function(e){
        if(e.newState === 'open'){
          content.style.height = '0px';
          content.style.transition = 'height .25s ease';
          requestAnimationFrame(function(){
            content.style.height = content.scrollHeight + 'px';
          });
          content.addEventListener('transitionend', function te(){
            content.style.height = '';
            content.style.transition = '';
            content.removeEventListener('transitionend', te);
          }, { once:true });
        }else{
          var h = content.scrollHeight;
          content.style.height = h + 'px';
          content.style.transition = 'height .25s ease';
          requestAnimationFrame(function(){ content.style.height = '0px'; });
          content.addEventListener('transitionend', function tc(){
            content.style.transition = '';
            content.removeEventListener('transitionend', tc);
          }, { once:true });
        }
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  }else{
    initAll(document);
  }
  ['shopify:section:load','shopify:section:select','shopify:block:select'].forEach(function(evt){
    document.addEventListener(evt, function(e){ initAll(e.target); });
  });
  document.addEventListener('shopify:section:unload', function(e){
    e.target.querySelectorAll(ROOT).forEach(function(root){
      delete root.dataset.ptabsInitialized;
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
